import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import regulationService from './regulationService'

// Get RegulationCategory
export const ListRegulationCategory = createAsyncThunk(
  'regulation-category-list',
  async (params: {}, thunkAPI) => {
    try {
      return await regulationService.regulationCategoryList({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create RegulationCategory
export const createRegulationCategory = createAsyncThunk(
  'regulation-category-create',
  async (data: {}, thunkAPI) => {
    try {
      return await regulationService.regulationCategoryCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get RegulationCategory id
export const editRegulationCategory = createAsyncThunk(
  'regulation-category-edit',
  async (id: string, thunkAPI) => {
    try {
      return await regulationService.regulationCategoryEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete RegulationCategory
export const deleteRegulationCategory = createAsyncThunk(
  'regulation-category-delete',
  async (id: string, thunkAPI) => {
    try {
      return await regulationService.regulationCategoryDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Regulation
export const ListRegulation = createAsyncThunk('regulation-list', async (params: {}, thunkAPI) => {
  try {
    return await regulationService.regulationList({params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create Regulation
export const createRegulation = createAsyncThunk(
  'regulation-create',
  async (data: {}, thunkAPI) => {
    try {
      return await regulationService.regulationCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Regulation id
export const editRegulation = createAsyncThunk('regulation-edit', async (id: string, thunkAPI) => {
  try {
    return await regulationService.regulationEdit(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Regulation view
export const viewRegulation = createAsyncThunk('regulation-view', async (id: string, thunkAPI) => {
  try {
    return await regulationService.regulationView(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete Regulation
export const deleteRegulation = createAsyncThunk(
  'regulation-delete',
  async (id: string, thunkAPI) => {
    try {
      return await regulationService.regulationDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type RegulationState = {
  record: any
  records: any
  errors: any
}

const initialState: RegulationState = {
  records: {
    data: [],
  },
  record: {},
  errors: '',
}

export const regulationSlice = createSlice({
  name: 'regulation',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ListRegulationCategory.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(editRegulationCategory.fulfilled, (state, action: PayloadAction<any>) => {
        state.record = action.payload
      })
      .addCase(ListRegulation.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(editRegulation.fulfilled, (state, action: PayloadAction<any>) => {
        state.record = action.payload
      })
  },
})

export const {reset} = regulationSlice.actions
export default regulationSlice.reducer
